import React from 'react';
import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import CarouselComponent from './components/Carousel';
import MainHeader from './components/Header';
import MainBody from './components/Body';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <MainHeader />
      <CarouselComponent />
      <MainBody />
      <Footer />
    </div>
  );
}

export default App;
